// Design System FormStepper Component
// Multi-step form navigation

import React from 'react';
import { 
  Stepper, 
  Step, 
  StepLabel, 
  StepButton,
  StepContent,
  Box,
  styled 
} from '@mui/material';
import PropTypes from 'prop-types';
import { colorTokens, spacingTokens } from '../../tokens';

// Styled Stepper
const StyledStepper = styled(Stepper)(({ theme }) => ({
  padding: spacingTokens.layout.md,
  backgroundColor: 'transparent',
}));

/**
 * FormStepper - Multi-step form navigation component
 * 
 * @example
 * <FormStepper activeStep={activeStep}>
 *   <Step key="basic">
 *     <StepLabel>Basic Information</StepLabel>
 *   </Step>
 *   <Step key="details">
 *     <StepLabel>Additional Details</StepLabel>
 *   </Step>
 *   <Step key="review">
 *     <StepLabel>Review & Submit</StepLabel>
 *   </Step>
 * </FormStepper>
 */
const FormStepper = ({
  activeStep = 0,
  orientation = 'horizontal',
  alternativeLabel = true,
  children,
  ...props
}) => {
  return (
    <StyledStepper
      activeStep={activeStep}
      orientation={orientation}
      alternativeLabel={orientation === 'horizontal' && alternativeLabel}
      {...props}
    >
      {children}
    </StyledStepper>
  );
};

FormStepper.propTypes = {
  activeStep: PropTypes.number,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  alternativeLabel: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default FormStepper;
export { Step, StepLabel, StepButton, StepContent };